
import { authHeader } from '../../_helpers';
import axios from 'axios';

export const editSellerService = {
    updateSeller,
    deleteSeller,
    setSellerImage
};

axios.defaults.headers.common = authHeader();

function updateSeller(data, id) {

    return axios.put('/users/seller/update/' + id + '/', data).then(response => {
        return response;
    });
}

function deleteSeller(data) {
    return axios.post('/users/seller/delete/', data)
        .then(response => {
            return response;
        });
}


function setSellerImage(data) {
    return axios.post('/users/seller/delete/', data)
        .then(response => {
            return response;
        });
}



// WEBPACK FOOTER //
// ./src/_services/sellers/editSeller.service.js